import { css } from '@emotion/react';
import { theme } from 'global';

const TRACK_HEIGHT = 6;
const BORDER_RADIUS = TRACK_HEIGHT / 2;

export const progressTrack = css`
  height: ${TRACK_HEIGHT}px;
  width: 100%;
  background-color: ${theme.colors.neutral[100]};
  border-radius: 0;
  overflow: hidden;
  margin-bottom: 20px;
`;

export const progressFill = (percent: number) => css`
  height: 100%;
  width: ${percent}%;
  border-radius: ${percent === 100
    ? '0'
    : `0 ${BORDER_RADIUS}px ${BORDER_RADIUS}px 0`};
  background-color: ${theme.colors.primary.main};
  transition: width 300ms ease;
`;
